import React from 'react';


const CaseListItem = ({item}) => (
    <div className="case-list-item">
        <div className="case-list-item-img">
            <img src={item.Thumbnail} alt="" />
        </div>
        <div className="case-list-item-link">
            <a href={`#/casedetail/${item.ID}`} target="_blank">{item.Title}</a>
        </div>
    </div>
);



const CaseList = ({items}) => {
    return (
        <div className="block-content case-list">
        {
            items.map((n, i) => {
                return(<CaseListItem key={i} item={n} />);
            })
        }
        </div>
    );
}

export default CaseList;


// WEBPACK FOOTER //
// ./src/components/CaseList.js